import { render, staticRenderFns } from "./chrome.vue?vue&type=template&id=61862226&scoped=true"
import script from "./chrome.vue?vue&type=script&lang=js"
export * from "./chrome.vue?vue&type=script&lang=js"
import style0 from "./chrome.vue?vue&type=style&index=0&id=61862226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61862226",
  null
  
)

export default component.exports